import React from 'react';
import PropTypes from 'prop-types';
import { Label, Icon } from 'semantic-ui-react';

const AddedBy = ({ isAutoAdded, createdBy }) => {
  if (isAutoAdded) {
    return (<Label basic color="green"><Icon name="cogs" />system</Label>);
  }

  return (<Label basic color="grey"><Icon name="user" />{createdBy}</Label>);
};

AddedBy.propTypes = {
  isAutoAdded: PropTypes.bool.isRequired,
  createdBy: PropTypes.string.isRequired,
};

export default AddedBy;



/** WEBPACK FOOTER **
 ** ./src/components/delete-asset-dialog/added-by.js
 **/